import {
  CustomPopoverProps,
  IconType,
  SortableListItem,
} from '@aibees/shared/components';
import { PopoverType } from '@aibees/shared/components/custom-popover/use-popover';
import { SxStyleThemeValueFunc } from '@aibees/shared/theme';
import { LoadingButtonProps } from '@mui/lab';
import { ReactNode } from 'react';

export interface TransferListProps
  extends Omit<CustomPopoverProps, 'onSubmit'> {
  requireAtLeastOne?: boolean;
  requireAtLeastOneText?: string;
  includedTitle?: string;
  excludedTitle?: string;
  tooltipTitle?: string;
  title?: string;
  icon?: IconType;
  saveButtonProps?: LoadingButtonProps;
  items?: TransferListItem[];
  config?: TransferListConfig;
  onSubmit?: (included?: string[], excluded?: string[]) => void;
  dialogMode?: boolean;
  state?: PopoverType;
  presetId?: string;
  loading?: boolean;
}

export interface TransferListConfig {
  items?: TransferListItem[];
  limit?: number;
  sortable?: boolean;
  groupedItems?: TransferListGroupItems[];
}

export interface TransferListItem extends SortableListItem {
  label?: string | ReactNode;
  default?: boolean;
  disable?: boolean;
  excluded?: boolean;
  icon?: IconType;
  iconColor?: string | SxStyleThemeValueFunc;
  type: TransferListType;
}

export interface TransferListPresetValue {
  included: string[];
  excluded: string[];
  columns?: TransferListItem[];
  default?: boolean;
}

export enum TransferListType {
  Departments = 'Departments',
  People = 'People',
  Company = 'Company',
}

export type TransferListGroupIcon = Record<TransferListType, IconType>;

export type TransferListGroupItems = {
  label: string;
  icon?: IconType;
  groupColor?: string | SxStyleThemeValueFunc;
};
